import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import { Form, Col, Row } from 'react-bootstrap'



import { Formik } from 'formik';
import * as yup from 'yup';


import moment from 'moment'

import Dialog from '../../services/Dialogs'



import { REG_CURP, REG_RFC, REG_NOMBRES, REG_SS, curp2date } from '../../services/funcionesPublicas'



const ModalEditarCiudadano = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, ciudadano } = params


var mensaes_validacion_generico = 'Este campo es obligatorio'


  const dialog = new Dialog();


const schema = yup.object().shape({

  curp: yup.string().required(mensaes_validacion_generico).matches( REG_CURP , "Formato de CURP invalido").required('El CURP es un campo obligatorio'),
  rfc: yup.string().required(mensaes_validacion_generico).matches( REG_RFC , "Formato de RFC invalido").required('El RFC es un campo obligatorio'),
  email: yup.string().email('Formato de Email no valido'),
  celular: yup.string().matches(/^\d{10}$/,"Formato no valido"),
  telefono: yup.string().matches(/^\d{10}$/,"Formato no valido"),

  nombres: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required(mensaes_validacion_generico),
  paterno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required(mensaes_validacion_generico),
  materno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido"),

  seguro_social: yup.string().matches( REG_SS ,'El formato de Número de Seguro Social no es correcto'),

  direccion: yup.string().nullable(),
  colonia: yup.string().nullable(),
  cp: yup.string().required(mensaes_validacion_generico),



});


const [ envio_server, setSeEnvio ] = useState<boolean>(false)

const enviarFormulario = async (nuevo_usuario:any,event:any,) =>{
      await dialog.open({
        accept: 'Sí, Actualizar',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: `
          <dl>
            <dt>Nombre</dt>
            <dd>`+nuevo_usuario.nombres+` `+nuevo_usuario.paterno+` `+nuevo_usuario.materno+`</dd>
            <dt>CURP</dt>
            <dd>`+nuevo_usuario.curp+`</dd>
            <dt>RFC</dt>
            <dd>`+nuevo_usuario.rfc+`</dd>
            <dt>Teléfono</dt>
            <dd>`+(nuevo_usuario.telefono||'No Proporcionado')+`</dd>
            <dt>Celular</dt>
            <dd>`+(nuevo_usuario.celular||'No Proporcionado')+`</dd>
            <dt>Correo Electrónico</dt>
            <dd>`+(nuevo_usuario.email||'No Proporcionado')+`</dd>
          </dl>
        `
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{


        setSeEnvio(true)
      // console.log('lo que se envia es:', nuevo_usuario)
        let res_nuevo_usuario = await RequestService.update(`solicitante/actualizar/${ciudadano.uuid}`, {   ...nuevo_usuario, 
                                                                                                                  fecha_nacimiento : curp2date(nuevo_usuario.curp), 
                                                                                                                  sexo : nuevo_usuario.curp.substr(10,1)==='H'?'H':'M' 
                                                                                                              })

        if(res_nuevo_usuario){
          toast.warning('La información de este solicitante fue actualizada')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Error al dar de alta.')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}


  return (
    <>
      <Modal show={show} size="lg" onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Editar Información Personal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(ciudadano)
          }



    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{

      telefono:  ciudadano.telefono || '',
      celular:  ciudadano.celular || '',
      email:  ciudadano.email || '',

      curp:  ciudadano.curp,
      rfc:  ciudadano.rfc,
      seguro_social:  ciudadano.seguro_social,
      nombres:  ciudadano.nombres,
      paterno:  ciudadano.paterno,
      materno:  ciudadano.materno,

      direccion: ciudadano.direccion,
      colonia: ciudadano.colonia,
      cp: ciudadano.cp,


      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>



          <h5>Información Personal</h5>

          <Row >
            <Form.Group as={Col} md="4" className="mb-3" controlId="nombres">
              <Form.Label>Nombre(s)</Form.Label>
              <Form.Control
                type="text"
                required
                name="nombres"
                value={values.nombres}
                onChange={(e)=>{ setFieldValue('nombres', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.nombres}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-3" controlId="paterno">
              <Form.Label>Apellido Paterno</Form.Label>
              <Form.Control
                type="text"
                required
                name="paterno"
                value={values.paterno}
                onChange={(e)=>{ setFieldValue('paterno', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.paterno}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-3" controlId="materno">
              <Form.Label>Apellido Materno</Form.Label>
              <Form.Control
                type="text"
                name="materno"
                value={values.materno}
                onChange={(e)=>{ setFieldValue('materno', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.materno}
              />

              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
          </Row>




          <Row >
            <Form.Group as={Col} md="6" className="mb-3" controlId="curp">
              <Form.Label>CURP </Form.Label>
              <Form.Control
                type="text"
                required
                name="curp"
                value={values.curp}
                onChange={(e)=>{ setFieldValue('curp', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.curp}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
            <Col md="3">
              { 
                REG_CURP.test(values.curp) &&(
              <div className="mb-3">
                <label className="form-label">Sexo</label>
                <input type="text" readOnly value={values.curp.substr(10,1)==='H'?'HOMBRE':'MUJER'} className="form-control" />
              </div>
                )
              }
            </Col>
            <Col md="3">
              { 
                REG_CURP.test(values.curp) &&(
              <div className="mb-3">
                <label className="form-label">Fecha de Nacimiento</label>
                <input type="text" readOnly value={curp2date(values.curp)} className="form-control" />
              </div>
                )
              }
            </Col>
          </Row>


          <Row >

            <Form.Group as={Col} md="4" className="mb-3" controlId="rfc">
              <Form.Label>RFC </Form.Label>
              <Form.Control
                type="text"
                required
                name="rfc"
                value={values.rfc}
                onChange={(e)=>{ setFieldValue('rfc', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.rfc}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4" className="mb-3" controlId="direccion">
              <Form.Label>Seguro Social</Form.Label>
              <Form.Control
                type="text"
                name="seguro_social"
                value={values.seguro_social}
                onChange={(e)=>{ setFieldValue('seguro_social', e.target.value.toUpperCase() ) }}
                isInvalid={!!errors.seguro_social}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>

          </Row>



        <hr className="border border-primary border-3 opacity-75 mb-4"/>

        <h5>Información de Contacto</h5>

          <Row>
            <Form.Group as={Col} md="4" className="mb-3" controlId="email">
              <Form.Label>Correo Electrónico</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={values.email}
                onChange={(e)=>{ setFieldValue('email', e.target.value ) }}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-3" controlId="telefono">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="text"
                name="telefono"
                value={values.telefono}
                onChange={(e)=>{ setFieldValue('telefono',e.target.value) }}
                isInvalid={!!errors.telefono}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-3" controlId="celular">
              <Form.Label>Celular</Form.Label>
              <Form.Control
                type="text"
                name="celular"
                value={values.celular}
                onChange={(e)=>{ setFieldValue('celular',e.target.value) }}
                isInvalid={!!errors.celular}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
          </Row>





              <h4 style={{marginTop: 20}}>Información de Localización</h4>

            <Row className="mb-3">

              <Form.Group>
                <Form.Label>Dirección</Form.Label>
                <Form.Control
                  type="text"
                  name="direccion"
                  value={values.direccion}
                  onChange={(e)=>{ setFieldValue('direccion',e.target.value.toUpperCase()) }}
                  isInvalid={!!errors.direccion}
                />
                  <Form.Control.Feedback type="invalid">
                    {errors.direccion}
                  </Form.Control.Feedback>
              </Form.Group>

            </Row>





            <Row className="mb-3 mt-3">

                <Form.Group as={Col} md="8">
                  <Form.Label>Colonia</Form.Label>
                  <Form.Control
                    
                    type="text"
                    name="colonia"
                    value={values.colonia}
                    onChange={(e)=>{ setFieldValue('colonia',e.target.value.toUpperCase()) }}
                    isInvalid={!!errors.colonia}
                  />
                    <Form.Control.Feedback type="invalid">
                      {errors.colonia}
                    </Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group as={Col} md="4">
                  <Form.Label>C.P.</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="cp"
                    value={values.cp}
                    onChange={handleChange}
                    isInvalid={!!errors.cp}
                  />
                    <Form.Control.Feedback type="invalid">
                      {errors.cp}
                    </Form.Control.Feedback>
                </Form.Group>

            </Row>




          
        </Form>
      )}
    </Formik>






        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalEditarCiudadano;